import React from 'react'

const CaretDown = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M20.184 9.317A1.017 1.017 0 0 0 19.437 9H4.563c-.288 0-.537.106-.748.317-.21.212-.315.463-.315.753s.105.54.315.751l7.438 7.486c.21.212.46.318.747.318.288 0 .537-.106.747-.318l7.437-7.486c.21-.211.316-.462.316-.752s-.105-.54-.316-.752z" fill="currentColor"/>
</svg>
)

export default CaretDown
